import Public from './Public';
import Client from './Client';

export default [...Public, ...Client];
